import { useState, useEffect, useCallback } from 'react';
import { teamsDetailService } from '../services/teamsDetail.service';
import type { TeamDetailData } from '../types/teamsDetail.types';
import { useAuth } from '@/core/auth/AuthContext';

export function useTeamDetail(id: string) {
  const { user } = useAuth();
  const userId = user?.id || '';
  
  const [data, setData] = useState<TeamDetailData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<any>(null);

  const fetchData = useCallback(async () => {
    if (!id || !userId) return;
    setIsLoading(true);
    try {
      const res = await teamsDetailService.getTeamDetail(id, userId);
      setData(res);
    } catch (err) {
      console.error('[useTeamDetail] Error fetching detail:', err);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [id, userId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    data,
    isLoading,
    error,
    refresh: fetchData
  };
}
